module.exports = __webpack_public_path__ + "img/Follow up the hotspots in the field 2.3d14ff34.png";